export default {
  showReport(response, exportToExcel) {
    let basicData = {
      FileFormat: exportToExcel ? "Excel" : "PDF",
      FileExtension: exportToExcel ? ".xls" : ".pdf"
    };
    let fileName = "ReportName";
    let arg = response.split("|");
    if (arg[0] == "TRUE") {
      var base64Data = this.b64toBlob(arg[2]);
      if (window.saveAs) {
        window.saveAs(base64Data, fileName);
      } else if (navigator.SaveBlob) {
        navigator.SaveBlob(base64Data, fileName);
      } else if (navigator.msSaveBlob) {
        navigator.msSaveBlob(base64Data, fileName);
      } else {
        fileName = arg[1];
        var forexcel = basicData.FileExtension.toString();
        var linkSource = "data:application/" + forexcel + ";base64," + arg[2];
        var downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    } else {
      return false;
    }
  },
  b64toBlob(b64Data) {
    let contentType = "";
    let sliceSize = 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
};



// WEBPACK FOOTER //
// ./src/router/Report.js